export default "__VITE_ASSET__CTSyGkkS__"